// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4006) return "static/chunks/clerk-5e2dd5a6a4185103.js";
	if (chunkId === 6209) return "static/chunks/ui-2eae0f23332b975a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5012":"cdcff7aacceb81ef","5991":"82f65124d63220b9","7993":"4947412e5c05bd20"}[chunkId] + ".js";
};